// usePrefersReducedMotion — реактивно отражает системную настройку
// «уменьшить движение». Единый источник для JS-управляемых анимаций
// (count-up, rAF-эффекты, условный рендер тяжёлых переходов). CSS-анимации
// гейтятся через @media (prefers-reduced-motion) в styles.css — этот хук для
// случаев, где решение принимается в JS.

import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

export function usePrefersReducedMotion(): boolean {
	const [reduced, setReduced] = useState<boolean>(() => {
		if (typeof window === "undefined") return false;
		return window.matchMedia(QUERY).matches;
	});

	useEffect(() => {
		if (typeof window === "undefined") return;
		const mql = window.matchMedia(QUERY);
		const onChange = (e: MediaQueryListEvent): void => setReduced(e.matches);
		mql.addEventListener("change", onChange);
		setReduced(mql.matches);
		return () => mql.removeEventListener("change", onChange);
	}, []);

	return reduced;
}
